// eslint-disable-next-line import/prefer-default-export
export const EMPLOYEE_REQUEST_STATUS = {
  OPEN: 'open',
  FINISHED: 'finished',
};
